<template>
    <div>
    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>Data Pegawai</h4>
				<div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                		<li><a href="/">Profil</a></li>
                    	<li><router-link to="/struktur_organisasi">Struktur Organisasi</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->
    
    
    <!--Content Wrap Start-->
    <div class="kode_content">
    	
        <!--Team Listing Wrap Start-->
        <section class="kf_team_listing_bg">
        	<div class="container">
            	<div class="row">
                    <!-- list mulai di sini -->
                	<div class="col-md-4 col-sm-6" v-for="data in list_data" :key="data.id">
                    	<div class="kode_politician">
                        	<figure>
                            	<img :src="file_path+data.foto" alt="Image Here" style="display: block;width: 100%;height: 350px">
                                <figcaption class="kode_poli_img_des">
                                	<h6><a href="javascript:void(0);">{{data.nama}}</a></h6>
                                	<span>{{data.jabatan}}</span>
                                    <p> {{data.trackr}}</p>
                                </figcaption>
                            </figure>
                            <div class="kode_politician_des">
                            	<h6><a href="javascript:void(0);">{{data.nama}} </a></h6>
                                <p>{{data.jabatan}} </p>
 
                            </div>
                        </div>
                    </div>
                    <!-- list mulai di sini -->

                    <!--Pagination Wrap Start-->
                    <div class="kode_pagination">
                        <ul class="pagination">
                                                                <div class="text-center">
                                    <button @click="btn_prev" type="button" class="btn " id="pref">
                                        <span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
                                    </button>
                                    &nbsp;
                                    <span style="font-size: 85%; color: #a5a5a5">
                                        <b>{{page_first}} - {{page_last}}</b>
                                    </span>
                                    &nbsp;
                                    <button @click="btn_next" type="button" class="btn" id="next">
                                        <span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
                                    </button>
                                </div>
                    
                        </ul>
                    </div>
                    <!--Pagination Wrap End-->
                    
 
                    
                </div>
            </div>
        </section>
        <!--Team Listing Wrap End-->
        
    </div>        
    </div>
</template>


<script>

const ADD_URL = URL_APP + "api/v1/publish_data_pegawai/";
const FILE_LOAD = URL_APP + "uploads/";

    export default {
        data(){
            return{
                id: "",
                id_berita :"",
                createAt : '',
                createBy : '',
                deskripsi : '',
                nama: '',
                nip: '',
                jabatan: '',
                trackr: '',
                isi : '',
                judul : '',
                sumber : '',
                foto : '',
                HOST : URL_HOST+'/isi_berita/',
                file_path: FILE_LOAD,

                list_data: [],
                page_first: 1,
                page_last: 0,
                cari_value: "",
            }
        },

        methods: {
        getView: function() {
        fetch(ADD_URL + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            },
            body: JSON.stringify({
            data_ke: this.page_first,
            cari_value: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                console.log(res_data);
            });
        },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},
// ================== PAGINASI ====================

            




        },

        mounted() {
            this.getView();
        }
    }
</script>
 